<template>
  <h3 class="body-1-bold my-24">
    {{ i18n(translations.allCategoriesTitle) }}
  </h3>

  <RevCheckbox
    id="all_categories"
    v-model="allCategories"
    class="my-24"
    variant="full"
  >
    <template #label>
      {{ i18n(translations.allCategoriesLabel) }}
    </template>

    <template #description>
      {{ i18n(translations.allCategoriesDescription) }}
    </template>
  </RevCheckbox>

  <div v-if="categories?.length">
    <h3 class="body-1-bold my-24">
      {{ i18n(translations.someCategoriesTitle) }}
    </h3>

    <ul class="mb-24 list-none space-y-12">
      <li v-for="category in categories" :key="category.id">
        <RevCheckbox
          :id="category.id"
          v-model="selectedCategories"
          :disabled="allCategories"
          :value="category.id"
          variant="full"
        >
          <template #label>
            {{ category.name }}
          </template>
        </RevCheckbox>
      </li>
    </ul>
  </div>

  <RevButton
    class="mt-auto"
    :disabled="isDisabled"
    full-width="always"
    type="submit"
    variant="primary"
    @click="goToNextStep"
  >
    {{ i18n(translations.cta) }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevButton } from '@ds/components/Button'
import { RevCheckbox } from '@ds/components/Checkbox'

import translations from './CategoriesSelection.translations'

const { defaultValue, categories } = defineProps<{
  categories: merchantsAPI.AddressRuleCategory[] | undefined
  defaultValue: string[] | undefined | null
}>()
const emit = defineEmits(['next-step'])

const i18n = useI18n()
const selectedCategories = ref(defaultValue || [])
const allCategories = ref(defaultValue === null)
const isDisabled = computed(() => {
  return !allCategories.value && isEmpty(selectedCategories.value)
})

function goToNextStep() {
  emit('next-step', {
    categories: allCategories.value ? null : selectedCategories.value,
  })
}
</script>
